/* global indexedDB, IDBDatabase, IDBOpenDBRequest, IDBVersionChangeEvent */
const PPT_TRACKER_DB_NAME = "SlideTrackerLive";
const PPT_TRACKER_DB_VERSION = 2;
const PPT_SNAPSHOTS_STORE = "snapshots";
const PPT_DECKS_STORE = "deckStates";
const EXCEL_TRACKER_DB_NAME = "CarouselExcelWorkbookTracking";
const EXCEL_TRACKER_DB_VERSION = 1;
const EXCEL_WORKBOOK_STORE = "workbookRecords";
const LEGACY_TRACKER_DB_NAMES = ["SlideKnowledgeGraph", "SlideTrackerDB", "SlideTrackerOfflineQueue"];
function waitForTransaction(transaction) {
    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => resolve();
        transaction.onerror = () => reject(transaction.error);
        transaction.onabort = () => reject(transaction.error);
    });
}
function deleteDatabaseSilently(databaseName) {
    return new Promise((resolve) => {
        try {
            const request = indexedDB.deleteDatabase(databaseName);
            request.onsuccess = () => resolve();
            request.onerror = () => resolve();
            request.onblocked = () => {
                // Keep clear operations resilient even if another context has the DB open.
                setTimeout(resolve, 250);
            };
        }
        catch {
            resolve();
        }
    });
}
async function openExistingDatabase(dbName, version) {
    return new Promise((resolve) => {
        let createdDatabase = false;
        const request = indexedDB.open(dbName, version);
        request.onupgradeneeded = (event) => {
            const oldVersion = event.oldVersion;
            createdDatabase = oldVersion === 0;
        };
        request.onerror = () => resolve(null);
        request.onblocked = () => resolve(null);
        request.onsuccess = () => {
            const db = request.result;
            if (createdDatabase) {
                db.close();
                void deleteDatabaseSilently(dbName).then(() => resolve(null));
                return;
            }
            resolve(db);
        };
    });
}
async function countStoreRecords(db, storeName) {
    try {
        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
        const request = store.count();
        const count = await new Promise((resolve, reject) => {
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
        await waitForTransaction(tx);
        return count;
    }
    catch {
        return null;
    }
}
export async function fetchPptLiveTrackerStats() {
    const db = await openExistingDatabase(PPT_TRACKER_DB_NAME, PPT_TRACKER_DB_VERSION);
    if (!db)
        return null;
    try {
        if (!db.objectStoreNames.contains(PPT_SNAPSHOTS_STORE) || !db.objectStoreNames.contains(PPT_DECKS_STORE)) {
            return null;
        }
        const snapshotCount = await countStoreRecords(db, PPT_SNAPSHOTS_STORE);
        const deckCount = await countStoreRecords(db, PPT_DECKS_STORE);
        if (snapshotCount === null || deckCount === null) {
            return null;
        }
        return {
            snapshotCount,
            deckCount,
            estimatedSize: snapshotCount * 100 * 1024,
        };
    }
    finally {
        db.close();
    }
}
export async function fetchExcelLiveTrackerStats() {
    const db = await openExistingDatabase(EXCEL_TRACKER_DB_NAME, EXCEL_TRACKER_DB_VERSION);
    if (!db)
        return null;
    try {
        if (!db.objectStoreNames.contains(EXCEL_WORKBOOK_STORE)) {
            return null;
        }
        const workbookCount = await countStoreRecords(db, EXCEL_WORKBOOK_STORE);
        if (workbookCount === null) {
            return null;
        }
        return {
            workbookCount,
            estimatedSize: workbookCount * 100 * 1024,
        };
    }
    finally {
        db.close();
    }
}
export async function clearPptLiveTracker() {
    await deleteDatabaseSilently(PPT_TRACKER_DB_NAME);
    for (const dbName of LEGACY_TRACKER_DB_NAMES) {
        await deleteDatabaseSilently(dbName);
    }
}
export async function clearExcelLiveTracker() {
    await deleteDatabaseSilently(EXCEL_TRACKER_DB_NAME);
}
